import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import { __assign, __awaiter, __decorate, __extends, __generator, __spreadArrays } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { enumData, loading, userPrefPageSize } from '@/decorators';
import applyInvoice from './components/applyInvoice.vue';
import billingDeadlineRuleComponent from './components/billingDeadlineRule.vue';

var ReconciliationBillPage = function (_super) {
  __extends(ReconciliationBillPage, _super);

  function ReconciliationBillPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.rowSelection = {};
    _this.selectedList = [];
    _this.checkResultsData = [];
    _this.checkStateData = [];
    _this.treatmentStateData = [];
    _this.returnReceiptStateData = [{
      label: $t("\u672A\u4E0A\u4F20"),
      value: 1
    }, {
      label: $t("\u5DF2\u4E0A\u4F20"),
      value: 0
    }];
    _this.invoiceStateData = [];
    _this.confirmWayData = [];
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.accountList = [];
    _this.selectedListItem = [];
    _this.total = 0;
    _this.applyInvoiceSuccess = false;
    _this.datetimeDefaultValue = [];
    return _this;
  }

  ReconciliationBillPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.bill_start_time = this.$util.formatDateTime(arr[0]);
      this.searchData.bill_end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.bill_start_time = '';
      this.searchData.bill_end_time = '';
    }
  };

  ReconciliationBillPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('账单号'),
      dataIndex: 'bill_number_list',
      scopedSlots: {
        customRender: 'billNumbers'
      }
    }, {
      title: this.t('主体信息'),
      dataIndex: 'sign_body_info',
      scopedSlots: {
        customRender: 'signBody'
      }
    }, {
      title: this.t('期初余额'),
      align: 'right',
      dataIndex: 'start_balance',
      scopedSlots: {
        customRender: 'startBalances'
      }
    }, {
      title: this.t('期末余额'),
      align: 'right',
      dataIndex: 'end_balance',
      scopedSlots: {
        customRender: 'endBalances'
      }
    }, {
      title: this.t('账单周期'),
      dataIndex: 'bill_from_time',
      scopedSlots: {
        customRender: 'billTime'
      }
    }, {
      title: this.t('总金额'),
      align: 'right',
      dataIndex: 'all_total',
      scopedSlots: {
        customRender: 'allTotal'
      }
    }, {
      title: this.t('账单确认结果'),
      dataIndex: 'confirm_result_type',
      scopedSlots: {
        customRender: 'confirmResult'
      }
    }, {
      title: this.t('账单确认状态'),
      dataIndex: 'reconciliation_status',
      scopedSlots: {
        customRender: 'reconciliationStatus'
      }
    }, {
      title: this.t('操作'),
      dataIndex: 'bi_chargeable_time',
      width: 80,
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys, rowSelection) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
        _this.selectedListItem = __spreadArrays(rowSelection);
        _this.selectedListItem = _this.selectedListItem.filter(function (item) {
          return _this.selectedList.indexOf(item.reconciliation_id) > -1;
        });
      }
    };
    this.queryReconciliationList();
    this.queryAccountList();
  };

  ReconciliationBillPage.prototype.queryReconciliationList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            return [4, this.$api.finance.queryReconciliationList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  ReconciliationBillPage.prototype.queryAccountList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryAccountList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.accountList = data;
            return [2];
        }
      });
    });
  };

  ReconciliationBillPage.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      code_field: 'bill_number',
      code_value: undefined,
      account_code: undefined,
      reconciliation_result: undefined,
      reconciliation_status: undefined,
      handler_status: undefined,
      reply_status: undefined,
      confirm_type: undefined,
      begin_bill_to_time: undefined,
      end_bill_to_time: undefined,
      bill_start_time: undefined,
      bill_end_time: undefined,
      timeArr: []
    };
  };

  ReconciliationBillPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.queryReconciliationList();
  };

  ReconciliationBillPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryReconciliationList();
  };

  ReconciliationBillPage.prototype.initPage = function () {
    this.searchData.page_index = 1;
    this.selectedList = [];
    this.rowSelection.selectedRowKeys = [];
  };

  ReconciliationBillPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryReconciliationList();
  };

  ReconciliationBillPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.initPage();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryReconciliationList();
    });
  };

  ReconciliationBillPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
              postData["export"] = 1;
              postData.id_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData["export"] = 2;
              postData.id_list = this.selectedList;
            }

            return [4, this.$api.finance.queryReconciliationExport(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  ReconciliationBillPage.prototype.handleApplyInvoice = function () {
    var _this = this;

    console.log(this.selectedListItem);

    if (!this.selectedListItem.length) {
      return this.$message.warning(this.t('请选择要开发票的对账单'));
    }

    var signBody = this.selectedListItem.map(function (item) {
      return (item.sign_body_info || {}).account_code + (item.sign_body_info || {}).service_body_name;
    });
    var signBodySet = new Set(signBody.filter(function (item) {
      return item !== undefined;
    }));

    if (signBodySet.size !== 1) {
      return this.$message.warning(this.t('仅支持同一主体的对账单批量开票'));
    }

    var hasInvoiceList = this.selectedListItem.filter(function (item) {
      return item.is_has_invoice === true;
    });

    if (hasInvoiceList.length > 0) {
      var reconciliationNumberList = hasInvoiceList.map(function (item) {
        return item.reconciliation_number;
      });
      var reconciliationNumber = reconciliationNumberList.join();
      return this.$message.warning(this.t('[{0}]已申请过开票，请重新选择', [reconciliationNumber]));
    }

    var reconciliationStatusList = this.selectedListItem.filter(function (item) {
      return item.reconciliation_status !== _this.$enum.finance.ReconciliationStatusEnum.CONFIRMED;
    });

    if (reconciliationStatusList.length > 0) {
      return this.$message.warning(this.t('只有已确认的对账单支持开票，请重新选择!'));
    }

    var applyInvoiceMsg = this.$refs.applyInvoiceRef;
    applyInvoiceMsg.visible = true;
  };

  ReconciliationBillPage.prototype.handleApplyInvoiceSuccess = function () {
    this.applyInvoiceSuccess = true;
    this.queryReconciliationList();
  };

  ReconciliationBillPage.prototype.handleToInvoicePage = function () {
    this.applyInvoiceSuccess = false;
    this.$router.push({
      name: 'InvoiceListPage',
      params: {
        noCache: '1'
      }
    });
  };

  ReconciliationBillPage.prototype.handleShowBillingDeadlineRule = function () {
    var billingDeadlineRuleRef = this.$refs.billingDeadlineRuleRef;

    if (billingDeadlineRuleRef) {
      billingDeadlineRuleRef.visible = true;
    }
  };

  ReconciliationBillPage.prototype.handleToBillDataPage = function () {
    this.$router.push({
      name: 'BillDataPage',
      params: {
        noCache: '1'
      }
    });
  };

  __decorate([enumData('Finance/ReconciliationResultEnum')], ReconciliationBillPage.prototype, "checkResultsData", void 0);

  __decorate([enumData('Finance/ReconciliationStatusEnum')], ReconciliationBillPage.prototype, "checkStateData", void 0);

  __decorate([enumData('Finance/HandlerStatusEnum')], ReconciliationBillPage.prototype, "treatmentStateData", void 0);

  __decorate([enumData('Finance/ReconciliationStateEnum')], ReconciliationBillPage.prototype, "invoiceStateData", void 0);

  __decorate([enumData('Finance/ConfirmTypeEnum')], ReconciliationBillPage.prototype, "confirmWayData", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], ReconciliationBillPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], ReconciliationBillPage.prototype, "queryReconciliationList", null);

  __decorate([userPrefPageSize('reconciliationList')], ReconciliationBillPage.prototype, "getInitSearchData", null);

  ReconciliationBillPage = __decorate([Component({
    components: {
      applyInvoice: applyInvoice,
      billingDeadlineRule: billingDeadlineRuleComponent
    }
  })], ReconciliationBillPage);
  return ReconciliationBillPage;
}(Vue);

export default ReconciliationBillPage;